<style  scoped>
.ivu-table-cell {
  padding-left: 0px;
  padding-top: 0px;
  padding-bottom: 0px;
  padding-right: 0px;
}
</style>
<template>
  <div>
    <button type="button" class="btn btn-theme btn-sm pull-right" @click="fn_add_price">
      <i class="fa fa-plus"></i> 增加
    </button>
    <Table :columns="columns" :data="data">
      <template
        :slot="'priceattr'+v.id"
        v-for="(v,k) in type_price_attr"
        :v-bind:key="k"
        slot-scope="{row,index}"
      >
        <!-- <select class="form-control" transfer v-model="data[index].attrs[v.name]" :key="v.id">
          <option :value="m.id" :label="m.name" v-for="(m,n) in v.attrlist" :key="n"></option>
        </select>-->
        <Select transfer v-model="data[index].attrs[v.name]" :key="v.id">
          <Option :value="m.id" :label="m.name" v-for="(m,n) in v.attrlist" :key="n"></Option>
        </Select>
      </template>

      <template slot="stockquantity" slot-scope="{row,index}">
        <InputNumber style="width:100%" v-model="data[index].stockquantity" />
      </template>
      <template slot="price" slot-scope="{row,index}">
        <InputNumber style="width:100%" v-model="data[index].price" />
      </template>
      <template slot="promotion_price" slot-scope="{row,index}">
        <InputNumber style="width:100%" v-model="data[index].promotion_price" />
      </template>
      <template slot="integral" slot-scope="{row,index}">
        <InputNumber style="width:100%" v-model="data[index].integral" />
      </template>

      <template slot="action" slot-scope="{row,index}">
        <button
          type="button"
          class="btn btn-theme m-r-10 btn-sm"
          @click="fn_store_price(data[index],index)"
        >保存</button>
        <Poptip
          transfer
          confirm
          title="确认要删除此商品价格?"
          @on-ok="fn_remove_price(row,index)"
          ok-text="确认"
          cancel-text="取消"
        >
          <button class="btn btn-danger btn-sm" type="button">删除</button>
        </Poptip>
      </template>
    </Table>
  </div>
</template>
<script>
import { storeGoodsPriceData, removeGoodsPriceData } from "@/api/goods";
export default {
  //商品定价
  data() {
    return {
      goodsPriceList: [],
      data: [],
      columns: [],
      formData: {
        id: 0
      },
      editIndex: 0,
      type_price_attr: [],
      iniAttrs: {}
    };
  },
  watch: {
    goodsdata: {
      handler: function(val, old) {
        // console.log(val);
        this.columns = [];
        this.data = val.prices;
        this.type_price_attr = val.type_price_attr;
        //
        for (let index = 0; index < val.type_price_attr.length; index++) {
          this.type_price_attr[index].attrlist = [];

          let element = this.type_price_attr[index];
          //此商品定义的那个属性
          for (let k = 0; k < val.goods_price_attr.length; k++) {
            const ele = val.goods_price_attr[k];
            if (ele.attrid == element.id) {
              this.type_price_attr[index].attrlist.push({
                id: ele.id,
                name: ele.name
              });
            }
          }
          this.columns.push({
            title: element.name,
            slot: "priceattr" + element.id,
            width: 150
          });
        }
        this.columns.push(
          {
            title: "库存",
            slot: "stockquantity",
            width: 100,
            align: "left"
          },
          {
            title: "官方价",
            slot: "price",
            width: 100,
            align: "left"
          },
          {
            title: "销售价",
            slot: "promotion_price",
            width: 100,
            align: "left"
          },
          {
            title: "需要积分",
            slot: "integral",
            width: 100,
            align: "left"
          },
          {
            title: "操作",
            slot: "action",
            minWidth: 150,
            align: "left"
          }
        );
        this.iniAttrs = {};
        for (let index = 0; index < this.type_price_attr.length; index++) {
          const element = this.type_price_attr[index];
          this.iniAttrs[element.name] = 0;
        }
      }
    }
  },
  methods: {
    fn_add_price() {
      let formData = {
        id: 0,
        goodsid: this.goodsdata.id,
        attrs: this.iniAttrs,
        stockquantity: 0,
        price: 0,
        promotion_price: 0,
        integral: 0
      };
      console.log(formData);
      this.data.push(formData);
    },
    fn_remove_price(row, index) {
      if (row.id == 0) {
        this.data.splice(index, 1);
      } else {
        removeGoodsPriceData(row.id)
          .then(res => {
            this.data.splice(index, 1);
          })
          .catch(error => {
            this.$Message.error(error);
          });
      }
    },
    fn_store_price(row, index) {
      for (const key in row.attrs) {
        if (row.attrs.hasOwnProperty(key)) {
          const element = row.attrs[key];
          if (element == 0) {
            this.$Message.error(key + " 参数必填");
            return;
          }
        }
      }
      if( row.promotion_price <=0){
          this.$Message.error("销售价格不能设置为0");
            return;
      }

      storeGoodsPriceData(row)
        .then(res => {
          if (res.data.code == 200) {
            row.id = res.data.id;
            this.$Notice.success(res.data);
          } else {
            this.$Notice.error(res.data);
          }
        })
        .catch(error => {
          this.$Message.error(error);
        });
    }
  },
  props: ["typeList", "action", "goodsdata"]
};
</script>